import styled, { css } from 'styled-components'
import { MaxWidthGridV2 } from 'Layout'
import PlaceHolder from 'Components/PlaceHolder'
import AppButton from 'Components/AppButton'
import {
  TEXT_GREY, FONT_BASE_COLOR, OUTLINE_COLOR,
  PRIMARY_DARK_COLOR, SOLD_BANNER_COLOR, ERROR_COLOR, LISTED_AGO_COLOR, ASTERISK_COLOR,
  INSTANT_ESTIMATE_BG, OPEN_HOUSE_BACKGROUND, OPEN_HOUSE_OUTLINE,
} from '@CSSVars/colors'
import { BREAK_POINT_SM, BREAK_POINT_LG, BREAK_POINT_MD } from '@CSSVars/variables'

export const _ContentContainer = styled(MaxWidthGridV2)`
  padding: 0 0 32px!important;
  display: flex;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: row;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column-reverse;
    align-items: start;

    width: 100%;
    max-width: 100%;
    padding: 12px max(calc((100% - 700px)/2), 24px) 0 !important;

    background-color: white;
    position: relative;
    top: -20px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
  }
`

export const _LeftBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column-reverse;
    position: relative;

    > div {
      width: 100%;
    }
  }
`

export const _Offer = styled.div`
  padding: 3px 8px;
  display: flex;
  align-items: center;
  color: ${SOLD_BANNER_COLOR};
  border-radius: 4px;
  font-size: 12px;
  line-height: 15px;
  margin-right: 8px;
  height: auto;
  background: ${({ endDate }) => (endDate ? 'rgba(218, 5, 89, 0.1)' : 'rgba(7, 54, 75, 0.1)')};
  color: ${({ endDate }) => (endDate ? ERROR_COLOR : SOLD_BANNER_COLOR)};
  div {
    font-size: inherit;
    color: inherit;
    line-height: inherit;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: fit-content;
  }
`

export const _PlaceholderOffer = styled(PlaceHolder)`
  width: 50px;
`

export const _ListedAgo = styled.div`
  height: auto;
  padding: 3px 8px;
  display: flex;
  align-items: center;

  color: ${LISTED_AGO_COLOR};
  background: rgba(0, 151, 167, 0.1);
  border-radius: 4px;

  ${({ hidden }) => (hidden && 'display:none')};
  font-size: 12px;
  line-height: 15px;
  div {
    color: inherit;
    font-size: 12px;
    line-height: 15px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: fit-content;
  }
`

export const _PlaceholderListedAgo = styled(PlaceHolder)`
  width: 100px;
`

export const _LeftBottomRow = styled.div`
  display: flex;
  flex-direction: ${({ activeListing }) => (activeListing ? 'row' : 'column')};;
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    flex-direction: row;
    margin-top: 8px;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    justify-content: start;
    flex-direction: row;
    gap: 8px;
  }

`

export const _ListedAgoGroup = styled.div`
  display: flex;
  flex-direction: row;
  width: calc( 100% - 360px );
  @media screen and (max-width: 1280px) {
    width: calc( 100% - 320px );
  }
  @media screen and (max-width: 1160px) {
    width: calc( 100% - 250px );
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`


const titleMixin = css`
  margin: -4px 0 -2px;
  padding: 0;
  font-family: var(--primary-font);
  font-size: 38px;
  font-weight: 500;
  line-height: 44px;
  color: ${FONT_BASE_COLOR};
  text-transform: capitalize;
  pointer-events: visible;

  @media screen and (max-width: 767px) {
    font-size: 28px;
    line-height: 36px;
  }
`

export const _Title = styled.h1`
  ${titleMixin}
`

const addressMixin = css`
  max-width: 100%;
  /*overflow: hidden;*/
  /*white-space: nowrap;*/

  a {
    text-decoration: underline;
  }

  h2 {
    margin: 0;
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
    max-width: 100%;
  }

  h2, span {
    font-family: var(--secondary-font);
  }

  h2, span, a {
    color: ${TEXT_GREY};
    line-height: 24px;
    font-size: 16px;
    font-weight: 500;
    flex-shrink: 0;
  }

  @media (hover: hover){
    a:hover{
      color:${OUTLINE_COLOR};
    }
  }
  a:active{
    color: ${FONT_BASE_COLOR};
  }

  @media screen and (max-width: 767px) {
    h2, span, a {
      font-size: 14px;
    }

    h2 {
      margin-top: 4px;
      line-height: 22px;
    }
  }
`
export const _Address = styled.div`
  ${addressMixin}
`

export const _Details = styled.div`
  margin-top: 14px;
  span {
    // margin-top: 13px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    color: ${FONT_BASE_COLOR};
  }
  & div:first-child {
    font-size: inherit;
    color: inherit;
    display: inline-flex;
    font-weight: inherit;
    flex-wrap: ${({ isPrecon }) => (isPrecon ? 'nowrap' : 'wrap')};
    /* align-items: ${({ isPrecon }) => (isPrecon ? '' : '')}; */
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 24px;

    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
  @media screen and (max-width: 450px) {
    width: 100%;
    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }

`

export const _IconStyle = css`
  display: flex;
  flex-direction: column !important;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  span {
    font-weight: 500;
  }
  @media screen and (max-width: 767px) {
    margin-right: 14px;
    white-space: nowrap;
    justify-content: start;
    text-align: center;
  }
`

export const _BedDetails = styled.div`
  ${_IconStyle};
  width: auto;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex: 0 0 30%;
    margin-right: 0;
    border-right: 1px solid ${OUTLINE_COLOR};
  }


`
export const _BathDetails = styled.div`
  ${_IconStyle};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex: 0 0 30%;
    margin-right: 0;
    border-right: 1px solid ${OUTLINE_COLOR};
  }

`

export const _ParkingDetails = styled.div`
  ${_IconStyle};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex: 0 0 30%;
    margin-right: 0;
  }
`
export const _SqftDetails = styled.div`
  ${_IconStyle};
  position: relative;
  white-space: break-spaces !important;
  min-width: 80px;
  .tooltipTrigger {
    width: 16px !important;
    height: 16px !important;
    position: absolute;
    top: 0;
    right: 0px;
  }
  .rc-tooltip-inner {
    width: 250px !important;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex: ${({ isPrecon }) => (isPrecon ? '0 0 30%' : '0 0 45%')};
    margin-right: 0;
    margin-top: ${({ isPrecon }) => (isPrecon ? '0px' : '28px')};
    border-right: ${({ isPrecon }) => (isPrecon ? 'none' : `1px solid ${OUTLINE_COLOR}`)};
    .tooltipTrigger {
      top: 0;
      right: 14px;
    }
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    .rc-tooltip-inner {
      width: 200px !important;
    }
  }

`

export const _PropertyTypeDetails = styled.div`
  ${_IconStyle};
  path {
    fill: transparent;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex: 0 0 45%;
    margin-top: 28px;
  }

`
export const _RightBlock = styled.div`
  width: 360px;
  padding-top: 16px;
  display: flex;
  justify-content: end;

  @media screen and (max-width: 1280px) {
    width: 320px;
    flex-shrink: 0;
  }
  @media screen and (max-width: 1160px) {
    width: 250px;
    /*flex-shrink: 1;*/
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    justify-content: center;
    align-items: center;

    flex-direction: column;
  }
`

export const _InstantEstimate = styled.div`
  width: 275px;
  height: 44px;
  padding: 0 12px;
  margin: 8px 0;
  position: relative;
  border: 1px solid ${INSTANT_ESTIMATE_BG};
  border-radius: 10px;
  // overflow: hidden;
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;

  .estimateAnimation {
    margin-right: 12px;
  }
  svg {
    transform: scale(-1);
  }

  span {
    font-weight: 600;
    text-decoration: underline;
    margin-right: 18px;
  }

  .tooltipTrigger {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    color: transparent;
    border-color: transparent;
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: ${INSTANT_ESTIMATE_BG};
    opacity: .1;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    justify-self: center;
    .estimateArrow {
    position: absolute;
    right: 18px;
  }
  }
`

export const _NoInstantEstimate = styled.div`
  width: 275px;
  height: 44px;
  margin: 8px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const _RightBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ isPrecon }) => (isPrecon ? 'flex-end' : 'center')};
  justify-content: flex-start;
  width: max-content;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    align-items: center;

    width: 100%;
  }
`

export const _PlaceholderPrice = styled(PlaceHolder)`
  height: 38px;
  width: 200px;
`

export const _CalcCta = styled.button`
  color: ${PRIMARY_DARK_COLOR};
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  position: relative;
  border: none;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`
export const _CalcButton = styled(AppButton)`
  display: none;
  color: ${PRIMARY_DARK_COLOR};
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  border: 1px solid ${OUTLINE_COLOR};
  border-radius: 10px;
  height: 44px;
  margin: auto;
  width: calc(100% - 48px);
  max-width: 700px;
  padding: 0;
  background-color: white;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: block;
    width: 100%;
    color: inherit;
  }
`

export const _Price = styled.div`
  ${({ soldStatus, conditionalStatus }) => (soldStatus ? `
    div:nth-child(1) {
    &, span, div {
      color:  ${conditionalStatus ? FONT_BASE_COLOR : ERROR_COLOR};
      font-size: 24px;
      line-height: 29px;
      font-weight: 600;
      display: inline;
      }
    }
    div:nth-child(2) {
    span, div {
      color: ${TEXT_GREY};
      font-size: 14px;
      line-height: 17px;
      font-weight: 500;
      display: inline;
    }
    }

  ` : `
    > div {
      color: ${FONT_BASE_COLOR};
      font-size: 38px;
      line-height: 45px;
      font-weight: 500;

    }
  `)}
  ${({ nowrap }) => (nowrap ? 'white-space: nowrap;' : '')};
  ${({ priceHidden }) => (priceHidden ? `
  > div {
    font-size: 24px;
    line-height: 29px;
    font-weight: 600;
  }

  ` : '')};

  @media screen and (max-width: 1160px) {
    text-align: end;
  }

  @media screen and (max-width: 767px) {
  ${({ soldStatus }) => (soldStatus ? `
    div:nth-child(1) {
    &, span, div {
      font-size: 18px;
      line-height: 21px;
      font-weight: 600;
      }
    }
    div:nth-child(2) {
     span, div{
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-align: start;
      }
    }

  ` : `
    > div {
      font-size: 28px;
    }
  `)}
  ${({ priceHidden }) => (priceHidden ? `
  > div {
    font-size: 28px;
    line-height: 45px;
    font-weight: 500;
  }

  ` : '')}
  }
`

export const _ListedPrice = styled.div`
  text-align: center;
  @media screen and (max-width: 767px) {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      text-align: start;
      margin-top: 6px;
      margin-bottom: 6px;
      display: flex;
      justify-content: center;
  }
`

export const _Calculator = styled.section`
  width: 100%;
  height: ${({ visible }) => (!visible ? '0' : 'auto')};
  margin-bottom: 1px;
  background-color: white;
  transition: height .3s;
  overflow: hidden;
  position: relative;
`

export const _CalcInner = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    padding-top: 44px;
  }
`

export const _CloseCalcCta = styled.div`
  position: absolute;
  top: 2px;
  right: 10px;
  cursor: pointer;
  height: 44px;
  width: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`


export const _AdminIcon = styled.div`
  display: inline-flex;
  margin: 8px 8px 0 0;
  a {
    font-size: 0;
  }

  @media screen and (max-width: ${BREAK_POINT_SM}) {
    margin: 8px 15px 8px 0;
    svg:nth-child(1) {
      margin-left: 0;
    }
  }
`

export const _AdminIconList = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 8px;
`

export const _HiddenFieldMessage = styled.div`
  padding-top: 16px;
  @media screen and (max-width: 767px) {
    margin-bottom: 0;
    padding-top: 12px;
  }

`
export const _DetailFiller = styled.div`
  min-height: 18px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
`

export const _Asterisk = styled.span`
  color: ${ASTERISK_COLOR} !important;

  `

export const _Disclaimer = styled.div`
  color: ${TEXT_GREY} !important;
  display: ${({ desktop }) => (desktop ? 'flex' : 'none')};
  font-size: 10px;
  line-height: 12px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: ${({ desktop }) => (!desktop ? 'flex' : 'none')};
    width: calc(100% - 48px);
    max-width: 700px;
    margin: -6px auto 24px auto;
  }

  `
export const _DirectionContainer = styled.div`
  position: relative;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid ${OUTLINE_COLOR};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 0 max(calc((100% - 700px)/2), 24px) 0 !important;
  img {
    width: 100%;
    height: 100px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    object-fit: cover;
  }
  @media screen and (min-width: ${BREAK_POINT_MD}) {
    display: none;
  }

  @media screen and (max-width: ${BREAK_POINT_SM}) {
    img {
      height: 60px;
    }
  }
`

export const _DirectionLink = styled.div`
  height: 35px;
  width: 100%;
  padding: 6px 0;
  text-align: center;
  line-height: 22px;
  font-size: 14px;
`

export const _DesktopPriceBlock = styled.div`
  display: block;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _MobilePriceBlock = styled.div`
  display: none;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: block;
  }
`

export const _EstimateLogin = styled(AppButton)`
  padding: 0;
  margin: 24px 0;
  height: 10px;
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  text-decoration: underline;
  color: ${PRIMARY_DARK_COLOR};
  background-color: transparent;
  border: none;
  line-height: 10px;
  // border: 1px solid ${OUTLINE_COLOR};
  width: auto;
  max-width: 700px;
  padding: 0;
  background-color: white;

  &:focus {
    background-color: transparent;
    color: ${PRIMARY_DARK_COLOR};
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    height: 44px;
    width: 100%;
    margin: 8px 0;
    border-radius: 10px;
    text-decoration: none;
    background-color: ${PRIMARY_DARK_COLOR};
    color: white;
  }
`

export const _OpenHouseAppCTA = styled.div`
  height: 44px;
  background: ${OPEN_HOUSE_BACKGROUND};
  max-width: 100%;
  border: 1px solid ${OPEN_HOUSE_OUTLINE};
  border-radius: 10px;
  margin: 8px max(calc((100% - 700px)/2), 24px) 0 !important;
  svg {
    path {
      fill: ${OPEN_HOUSE_OUTLINE};
    }
    margin-right: 9px;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  padding: 13px 10px 14px 12px ;
`
export const _OpenHouseText = styled.div`
  color: ${OPEN_HOUSE_OUTLINE};
  font-size: 14px;
  font-weight: 500;
  line-height: 17.07px;
  span {
    color: ${OPEN_HOUSE_OUTLINE};
    font-weight: 600;
  }
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
   width: 100%;
`
